import * as React from 'react';
import Announcements from './announcements';
import * as styles from './announcements.module.scss';

const GlobalAnnouncements = () => {
  return (
    <div>
      <div className={styles.header}>
        <h1>Global Announcement</h1>
      </div>
      <Announcements client="global" />
    </div>
  );
};

export default GlobalAnnouncements;
